import React from 'react'

interface Props {
	isoCode: string
}

export const CountryIcon: React.FC<Props> = ({ isoCode }) => (
	<span className="text-4xl leading-none">
		<span className={`fi fi-${isoCode.toLowerCase()} fis overflow-hidden rounded-full bg-cover align-middle`}>
			<span className="absolute inset-0 bg-gradient-to-r from-black opacity-15" />
		</span>
	</span>
)
